import { Card, CardHeader, Checkbox, Divider, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { useContext } from "react";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";
import { intersection, not, union } from "./utils";

export const CustomList = ({ title, items, checked, setChecked, styles, disabled }) => {

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const numberOfChecked = (items) => intersection(checked, items).length;

    const handleToggleAll = (items) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const context = useContext(AppContext)

    return (
        <Card variant='outlined'>
            <CardHeader
                className={styles.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items?.length && items?.length !== 0}
                        indeterminate={numberOfChecked(items) !== items?.length && numberOfChecked(items) !== 0}
                        disabled={items?.length === 0 || disabled}
                        inputProps={{ 'aria-label': 'all items selectedUsers' }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items?.length} selecionados`}
            />
            <Divider />
            <List className={styles.list} component="div" dense role="list">
                {items?.map((value) => {
                    const labelId = `transfer-list-all-item-${value.id}-label`;

                    return (
                        <ListItem key={`${value.id}-${value.class_id}`} className={styles.list_item} role="listitem" button onClick={handleToggle(value)} disabled={disabled}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    disabled={disabled}
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} style={{ alignItems: 'stretch' }} primary={`${value?.user?.name}`} secondary={`${value?.user?.email}`} />
                            <ListItemText style={{ textAlign: "right", flexGrow: 0, paddingInline: '8px' }} primary={value?.profile?.name} secondary={'⠀'} />
                            {
                                value?.class?.name && <ListItemText
                                    style={{ textAlign: "right", flexGrow: 0, paddingInline: '8px' }}
                                    primary={value?.class?.name}
                                    secondary={'Turma'}
                                />
                            }
                            {
                                context.profile.name === ProfileEnum.SUPERADMIN && <ListItemText
                                    style={{ textAlign: 'right', flexGrow: 0, paddingInline: '8px' }}
                                    primary={value?.institution_branch?.institution?.name}
                                    secondary={value?.institution_branch?.name}
                                />

                            }
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Card>
    )
}